import ServiceBase from './ServiceBase';

const attrKey = 'exam-attr';

class ExamService extends ServiceBase {
  async setAttr(attr) {
    if (this.store.state.token) {
      let ids = [];
      for (let key in attr) {
        let id = attr[key];
        if (id > 0) {
          ids.push(id);
        }
      }
      await this.http.post('/api/app/practice/userAttr', {
        attr_val_id: ids.join(','),
      });
    }
    this.vue.$storage().set(attrKey, attr);
  }

  async getAttr() {
    if (this.store.state.token) {
      let attr = {};
      let data = await this.http.get('/api/app/practice/userAttr');
      if (data.attr.length > 0) {
        data.attr.forEach((a) => {
          attr[a.id] = a.value;
        });
      }
      return attr;
    }
    return this.vue.$storage().get(attrKey) || {};
  }

  async getAttrValId() {
    let attr = await this.getAttr();
    let ids = [];
    for (let key in attr) {
      let id = attr[key];
      if (id > 0) {
        ids.push(id);
      }
    }
    return ids.join(',');
  }
}

export default () => {
  return new ExamService();
};
